import { Layout } from "./components/Layout";
import { PrinciplesContent } from "./ParentPrinciplesPage";

export default function AdminPrinciplesPage() {
  return (
    <Layout>
      <PrinciplesContent />
    </Layout>
  );
}
